import React, { useState, useCallback } from 'react';

import { Alert, Typography } from 'antd';

import FileUploader from 'components/FileUploader';
import { useFormikContext } from 'formik';
import type { INewAccount } from 'v2/interfaces/financial';

interface IProps {
  mediaPreview: any;
  setMediaPreview: (name: string, preview: any) => void;
}

const BankReceipt = ({ mediaPreview, setMediaPreview }: IProps) => {
  const { values, setSubmitting, setFieldValue } = useFormikContext<INewAccount>();
  const pathName = window.location.pathname;
  const isRefundAccount = pathName.includes('bank-account-refund');
  const [imgError, setImgError] = useState('');

  const handleUploadEvents = useCallback(
    (event: string, message?: string) => {
      if (event === 'uploading') {
        setSubmitting(true);
        return;
      }

      if (event === 'error') {
        setImgError(message);
      }
    },
    [setSubmitting]
  );

  const handleImageChange = useCallback(
    (name: string, id: number, preview: any) => {
      setMediaPreview(name, preview);

      setFieldValue('imgsIds', { ...values.imgsIds, [name]: id });
      setSubmitting(false);
    },
    [setFieldValue, setMediaPreview, setSubmitting, values.imgsIds]
  );

  return (
    <div className='flex flex-col gap-4'>
      <Typography.Text strong>
        Envie-nos um comprovante bancário válido e legível que comprove todos os dados bancários informados no
        formulário (passo 1).
      </Typography.Text>

      <FileUploader
        onChange={handleImageChange}
        fileName='imgBankReceipt'
        defaultPreview={mediaPreview['imgBankReceipt']}
        type='image'
        uploadType='mpg_docs'
        label='Comprovante bancário'
        onEvent={handleUploadEvents}
        isRefundAccount={isRefundAccount}
      />

      <Typography.Text type='secondary'>
        Envie arquivos nos formatos: JPG, PNG ou PDF. De no máximo 2mb.
      </Typography.Text>

      {imgError && <Alert type='error' showIcon message={imgError} />}
    </div>
  );
};

export default BankReceipt;
